module.exports = __webpack_public_path__ + "static/media/chat.05ae8b71.webp";


//////////////////
// WEBPACK FOOTER
// ./src/components/website-bot/img/chat.webp
// module id = 440
// module chunks = 0